<template>
  <div class="header_tab" ref="nav">
    <ul class="tab_content">
      <li
        v-for="(item, index) in tabList"
        :key="index"
        @click="up(item)"
        :id="item.id"
        :clstag="`newscenter|keycount|headerTab-pc|click-${item.code}`"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { getHomeList } from '@/api/news'
import { getUserInfo } from '@/api/registry-api'
import { getLang } from '@/utils'
import Cookie from 'js-cookie'
export default {
  components: {},
  data() {
    return {
      tabList: [],
      getLang: getLang(),
      user: false
    }
  },
  computed: {},
  watch: {},
  methods: {
    async getUser() {
      let ciftis_at = Cookie.get('ciftis_at')
      if (!ciftis_at) return
      let _data = await getUserInfo()
      if (_data.data.accountType === 'MEDIA') this.user = true
    },
    up(item) {
      const code = item.code
      const lang = Cookie.get('ciftis_site_lang')
      const normalizedCode = lang === 'en-US' ? code.replace(/1$/, '') : code

      // 需要登录才能访问的模块
      const needLoginCodes = ['Appointment Applications', 'Media Services']
      const needLogin = needLoginCodes.some(c => code.includes(c))
      if (needLogin && !this.user) {
        this.$router.push({ path: '/web/login' })
        return
      }

      // Event Agenda 跳转外部链接
      if (code.includes('Event Agenda')) {
        window.location.href = item.url
        return
      }

      // 在首页时，锚点定位到对应板块
      const anchorCodes = [
        'Appointment Applications',
        'Data Center',
        'Media Services',
        'Media Center Home',
        'Focus News',
        'Proceedings'
      ]
      if (window.location.pathname === '/home') {
        const matched = anchorCodes.find(c => code.includes(c))
        if (matched) {
          window.location.href = '#' + matched
        }
      }

      // News Trends 跳转通知列表
      if (code.includes('News Trends')) {
        this.$router.push({ path: '/notice', query: { code: 'News Trends' } })
        return
      }

      // Latest Notice 跳转通知页
      if (code.includes('Latest Notice')) {
        this.$router.push({ path: '/cover', query: { code: normalizedCode } })
        return
      }

      // CIFTIS Stories 跳转故事列表页
      if (code.includes('CIFTIS Stories')) {
        this.$router.push({ path: '/stories', query: { code: normalizedCode } })
        return
      }

      // 需要带 tabCode 跳转首页的模块
      const tabCodeModules = [
        'Appointment Applications',
        'Data Center',
        'Media Services',
        'Proceedings'
      ]
      if (tabCodeModules.some(c => code.includes(c))) {
        this.$router.push({ path: '/home', query: { tabCode: normalizedCode } })
        return
      }

      // 其余情况回首页
      this.$router.push({ path: '/home' })
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop // 滚动条偏移量
      // let middle = (document.documentElement.clientHeight - 230) / 2
      // if (this.$refs.layer) {
      //   if (785 - scrollTop <= middle) {
      //     this.$refs.layer.style = 'position:fixed;top:' + middle + 'px'
      //   } else {
      //     this.$refs.layer.style = 'position:absolute;top:785px'
      //   }
      // }
      if (this.$refs.nav) {
        if (scrollTop > 100) {
          this.$refs.nav.style = 'position:fixed;top:0;z-index:999;'
        } else {
          this.$refs.nav.style = ''
        }
      }
    }
  },
  created() {
    this.getUser()
    window.addEventListener('scroll', this.handleScroll)
  },
  async mounted() {
    const res = await getHomeList()
    this.tabList = res.result.data
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style scoped lang="scss">
.header_tab {
  width: 100%;
  height: 50px;
  background: linear-gradient(90deg, #fe8c01 0%, #ff6900 100%);
}
.tab_content {
  width: 1200px;
  height: 100%;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  li {
    width: auto;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    margin-right: 10px;
    padding: 0 20px;
    color: #fff;
    overflow: hidden;
  }
  li:hover {
    background: #ff9d26;
    cursor: pointer;
  }
}
</style>
